<template>
    <div id="layout">
        <div v-show="working > 0" class="lds-facebook"><div></div><div></div><div></div></div>
        <div id="content">
            <Menu></Menu>
            <div class="page-content">
                <div id="linkList">
                    <ul class="header-ul">
                        <li class="header stoned">
                            <span v-for="(column, key) in table.columns" v-bind:key="key" :class="column[1]">
                                <template v-if="table.sort_key === key">
                                    <a v-show="table.reverse === 1">&#8593;</a>
                                    <a v-show="table.reverse === -1">&#8595;</a>
                                </template>
                                <a v-on:click="nowSort(key)">{{column[0]}}</a>
                            </span>
                        </li>
                        <li class="searchbox">
                            <span class="five">
                                <a class="refresh" href="#" v-on:click="updateStatusAll"><refresh-cw-icon></refresh-cw-icon></a><search-input v-model="search_string"></search-input>
                            </span>
                            <span class="one"></span>
                            <span class="one right">Copy all links: <copy-link v-bind:classToSet="'big'" v-bind:text-to-copy="linksToCopy"></copy-link> Total: <strong>{{filteredLog.length}}</strong> </span>
                        </li>
                    </ul>
                    <ul>
                        <li v-if="filteredLog.length === 0 && working == 0"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></li>
                    </ul>
                    <transition-group name="list-complete" tag="ul">
                        <monitoring-row v-bind:blink="log_item.blink" v-bind:copy-u-r-l="copyURL" v-bind:key="log_item.id" v-for="log_item in filteredLog" v-bind:log_item="log_item" v-bind:update-status="updateStatus"></monitoring-row>
                    </transition-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import Storages from 'js-storage'

    import config from '@/config'

    import Menu from '@/components/small/Menu'
    import SearchInput from "@/components/small/SearchInput";
    import CopyLink from "@/components/UI/_base-UI-CopyLink";
    import MonitoringRow from "@/components/small/MonitoringRow";
    import Socket from '@/IOSocket'

    import { RefreshCwIcon} from 'vue-feather-icons'

    export default {
        name: "Monitoring",
        components:{
            MonitoringRow,
            CopyLink,
            SearchInput,
            Menu,
            RefreshCwIcon
        },
        data: function (){
            return {
                table:{
                    reverse: Storages.localStorage.isSet('reverse')?Storages.localStorage.get('reverse'):1,
                    sort_key: Storages.localStorage.isSet('sort_key')?Storages.localStorage.get('sort_key'):'host',
                    columns: {
                        'URL' : ['URL', 'two'],
                        'reason': ['Reason', 'one cent'],
                        'type': ['Type', 'one cent'],
                        'regex': ['RegEx', 'one cent'],
                        'description': ['Description', 'two'],
                    }
                },
                // last_id: 0,
                working: 0,
                log: [],
                search_string: ""
            }
        },
        beforeDestroy(){
            Socket.$off("message", this.wsMessage)
        },
        mounted: function(){
            this.getLog();
            Socket.$on("message", this.wsMessage)
        },
        computed: {
            filteredLog: function () {
                 return this.log.filter( (err) => {
                    return Object.keys(err).some( (key) => {
                        return String(err[key]).toLowerCase().indexOf(this.search_string) > -1
                    })
                }).sort( (a, b) => {
                    a = a[this.table.sort_key]
                    b = b[this.table.sort_key]
                    return (a === b ? 0 : a > b ? 1 : -1) * this.table.reverse;
                })
            },
            linksToCopy: function () {
                let links = [];

                this.filteredLog.forEach( value => {
                    links.push(value.URL)
                })

                return links.join('\n')
            }
        },
        methods: {
            wsMessage: function(msg){
                console.log("Received message:")
                console.log(msg);
                if (msg.service === 'monitoring') {
                    switch (msg.action) {
                        case 'new':{
                            this.newItem(msg.data);
                        }break;
                        case 'update':{
                            this.updateItem(msg.data);
                        }break;
                        default:{
                            this.updateItem(msg.data);
                        }break;
                    }
                }
            },
            copyAllURLs: function(){
                let all = [];
                console.log(this.log);
                this.filteredLog.forEach(item => {
                    all.push(item.URL)
                });

                copyToClipboard(all.join('\n'));
            },
            copyURL: function(url){
                copyToClipboard(url);
            },
            nowSort: function (new_key){
                if (this.table.sort_key === new_key){
                    this.table.reverse = -1*this.table.reverse;
                }else{
                    this.table.sort_key = new_key;
                    this.table.reverse = 1;
                }
                Storages.localStorage.set('sort_key', this.table.sort_key);
                Storages.localStorage.set('reverse', this.table.reverse);
            },
            // parsingTick: function (){
            //     this.log.forEach( (item, key) => {
            //         if (item.status != 'parsing'){return;}
            //         let request_url = config.api_url + '/?op=monitoring&cmd=get&id='+item.id;
            //         axios
            //             .get(request_url)
            //             .then(response => {
            //                 if (response.data == null){
            //                     console.log("Removed==================")
            //                     this.log.splice(key, 1);
            //                 }else {
            //                     this.log.splice(key, 1, response.data);
            //                 }
            //                 this.working--;
            //             })
            //             .catch(error => {
            //                 console.log(error);
            //                 this.working--;
            //             });
            //     });
            // },
            newItem: function (item_id) {
                let request_url = config.api_url + '/?op=monitoring&cmd=get&id=' + item_id;
                axios
                    .get(request_url)
                    .then(response => {
                        if (response.data !== null) {
                            response.data.blink = true;
                            this.log.push(response.data);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.working--;
                    });
            },
            updateItem: function(item_id){
                let request_url = config.api_url + '/?op=monitoring&cmd=get&id='+item_id;
                axios
                    .get(request_url)
                    .then(response => {
                        if (response.data == null) {
                            this.log = this.log.filter(function (obj) {
                                return obj.id !== item_id;
                            });
                        }else{
                            this.log.forEach((value,key) => {
                                if (value.id == response.data.id) {
                                    response.data.blink = true;
                                    this.log.splice(key, 1, response.data)
                                }
                            });
                        }
                        this.working--;
                    })
                    .catch(error => {
                        console.log(error);
                        this.working--;
                    });
            },
            updateStatus: function(log_item){
                log_item.status = 'parsing';
                this.working++;
                let request_url = config.api_url + '/?op=monitoring&cmd=add&id=' + log_item.id;
                axios
                    .get(request_url)
                    .then(response => {
                        this.working--;
                    })
                    .catch(error => {
                        console.log(error)
                        this.working--;
                    });
            },
            updateStatusAll: function(){
                this.working++;
                this.log.forEach((item) => {
                    item.status = 'parsing';
                });
                let request_url = config.api_url + '/?op=monitoring&cmd=add_all';
                axios
                    .get(request_url)
                    .then(response => {
                        this.working--;
                    })
                    .catch(error => {
                        console.log(error)
                        this.working--;
                    });
            },
            getLog: async function () {
                this.log = [];
                this.working++;
                let request_url = config.api_url + '/?op=monitoring';
                axios
                    .get(request_url)
                    .then(response => {
                        if (response.data != null) {
                            this.log = response.data;
                        }
                        this.working--;
                    })
                    .catch(error => {
                        console.log(error)
                        this.working--;
                    });
            },
            // getLogUpdate: async function () {
            //     let request_url = config.api_url + '/?op=monitoring&cmd=get_after&id=' + this.last_id;
            //     axios
            //         .get(request_url)
            //         .then(response => {
            //             if (response.data != null) {
            //                 response.data.forEach((item) => {
            //                     this.log.push(item)
            //                 });
            //                 this.last_id = this.log[this.log.length - 1].log_id;
            //             }
            //         })
            //         .catch(error => {
            //             console.log(error)
            //         });
            // }
        }
    }
</script>
<style scoped>
    #linkList ul li.mygrid {
        display: grid;
        grid-template-columns: 2fr 0.5fr 0.5fr 1fr 4fr;
    }

    #content{
        flex-direction: column;
    }

    ul li a{
        color: #4e4872;
    }

    ul li span{
        width: 100%;
    }

    #linkList #list-wrap{
        max-height: 80%;
    }

    #linkList{
        box-sizing: border-box;
        background: #CCCCCC;
        width: 100%;
        height: 100%;
        border-right: 2px solid #b1b1b1;
        border-top: 2px solid #FFFFFF;
        border-bottom: 2px solid #656565;
        border-left: 2px solid #656565;
        box-shadow: 0px 0px 1px 1px #471932;
        display: flex;
        flex-direction: column;
    }

    #linkList ul li.header{
        text-align: left;
        list-style: none;
        display: grid;
        grid-template-columns: 2fr 0.5fr 0.5fr 1fr 4fr;
        border-top: 1px solid #b9f1ff;
        border-right: 1px solid #b9f1ff;
        background: #7bc4ff;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to bottom, #7bc4ff, #c7e9ff);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to bottom, #7bc4ff, #c7e9ff); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        padding: 0.5rem;
        color: #FFFFFF;
        text-decoration: underline;
        border-bottom: 1px solid #4d7399;
        border-left: 1px solid #4d7399;
        text-shadow: 1px 1px 0px #888;
    }

    #linkList ul li.header span:first-of-type{
        margin-left: 0.5rem;
    }

    .header span{
        cursor: pointer;
    }

    ul li span:first-of-type{
        margin-left: 0;
    }

    .header span:last-of-type, ul li span:last-of-type{
        margin-right: 0;
    }

    .header p{
        flex: 5 100%;
        margin-top: 0.5rem;
    }

    .header span.two, ul li span.two{
        flex: 2;
    }

    .header span.one, ul li span.one{
        flex: 1;
    }

    ul li{
        list-style: none;
        display: flex;
        flex-wrap: nowrap;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        padding: 0.5rem;
        color: #000000;
        border-bottom: 1px solid #888;
        border-left: 1px solid #888;
        text-shadow: none;
    }


    ul li.root{
        list-style: none;
        display: flex;
        flex-wrap: nowrap;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        background: #ffe986;  /* fallback for old browsers */
        padding: 0.5rem;
        color: #000000;
        border-bottom: 1px solid #888;
        border-left: 1px solid #888;
        text-shadow: none;
    }

    ul li.no-data{
        color: #a9a9a9;
        text-align: center;
        text-shadow: 1px 1px 0px #FFF;
    }

    ul li .shadow{
        color: #b9b9b9;
    }

    .lds-ellipsis.small {
        width: 28px;
        height: 28px;
    }

    .lds-ellipsis {
        text-align: center;
        display: block;
        position: relative;
        width: 64px;
        height: 64px;
        margin: auto;
    }

    .lds-ellipsis.small div {
        top: 8px;
        border-radius: 50%;
        background: #93291E;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #93291E;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 6px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 6px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 26px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 45px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }

    .list-complete-item {
        transition: all 0.6s;
        display: inline-block;
    }

    .list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
        opacity: 1;
        transform: translateY(30px);
    }
    .list-complete-leave-active {
        position: absolute;
    }
</style>
